const wizards: any = {
  'us-residency-certification-corporations': {
    DocumentTypeName: 'form-8802',
    title: 'Streamlined Application for U.S. Residency Certification',
    pages: [
      {
        page: 0,
        title: 'Tax Returns',
      },
      {
        page: 1,
        title: 'Certificate(s) For Past Years',
      },
      {
        page: 2,
        title: 'Countries Requested',
      },
      {
        page: 3,
        title: 'Review and Confirm',
      },
    ],
    investorType: 2,
    investorTypeName: 'Corporation',
  },
  'us-residency-certification-estates': {
    DocumentTypeName: 'form-8802',
    title: 'Streamlined Application for U.S. Residency Certification',
    pages: [
      {
        page: 0,
        title: 'Tax Returns',
      },
      {
        page: 1,
        title: 'Certificate(s) For Past Years',
      },
      {
        page: 2,
        title: 'Countries Requested',
      },
      {
        page: 3,
        title: 'Review and Confirm',
      },
    ],
    investorType: 10,
    investorTypeName: 'Estate',
  },
};

export default wizards;
